import {ModuleList} from "./ModuleList";
import {ModuleEdit} from "./ModuleEdit";
import {ModuleCreate} from "./ModuleCreate";
import { ModuleShow } from "./ModuleShow";

export default {
    list: ModuleList,
    create: ModuleCreate,
    edit: ModuleEdit,
    show: ModuleShow
};
